'use client';

import Link from 'next/link';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';

import { COPYRIGHT_CONFIG } from './helpers';
import { getCookie } from '@/helpers/common';
import {
  DOMAINS,
  PAYMENT_VERIFICATION_ORGANIZATION_IP,
} from '@/helpers/constants';
import { currentFullYear } from '@/helpers/dateTime';
import { USER_IP } from '@/helpers/variables';
import useEstonia from '@/hooks/estonia';

import { ScFooterCopyright } from './styled';

export const FooterCopyright = () => {
  const copyrightDomain =
    window.location.hostname === DOMAINS.OTHER ? DOMAINS.OTHER : DOMAINS.MAIN;

  const userIP = getCookie(USER_IP);

  const { isEstonia } = useEstonia();

  const { i18nKey, links } = useMemo(() => {
    if (userIP === PAYMENT_VERIFICATION_ORGANIZATION_IP) {
      return COPYRIGHT_CONFIG.alternative;
    }
    return isEstonia ? COPYRIGHT_CONFIG.estonia : COPYRIGHT_CONFIG.default;
  }, [isEstonia]);

  return (
    <ScFooterCopyright>
      <Trans
        ns="common"
        i18nKey={i18nKey}
        values={{ year: currentFullYear, domain: copyrightDomain }}
        components={{
          p: <p />,
          1: <Link href={links.terms} />,
          2: <Link href={links.responsibleGaming} />,
        }}
      />
    </ScFooterCopyright>
  );
};
